import { AbstractControl, ValidationErrors } from '@angular/forms';
import { skillMdConfigurationFileValidator } from './assistant-builder-skill-md-config.validators';

/**
 * A file entry as the generic/comparison/compliance forms carry it.
 *
 * `id` is the store/document uuid. The validators in this file only ever read
 * `name`, but these controls are written by `sd`-bound
 * `assistant-builder-file-upload`, whose `ControlValueAccessor` emits
 * `AssistantBuilderFileValue` — so an entry always *has* an id, and
 * `assistant-builder.page.ts`'s `getFiles()` depends on it: it maps each entry to
 * `documentId: file.id` for `documentsToAdd`. Declaring only `name` here forced
 * that reader to cast its way back to `{ id, name }`, and made a fixture without
 * an id look type-correct while producing `documentId: undefined`.
 */
export interface GenericAssistantFileLike {
  id: string;
  name: string;
}

export type AssistantBuilderTraitGenericFilesValue = GenericAssistantFileLike[];

export interface AssistantBuilderTraitGenericFormValues {
  sourceFiles: AssistantBuilderTraitGenericFilesValue;
  configurationFile: AssistantBuilderTraitGenericFilesValue;
}

/**
 * Generic-form binding of the shared skill.md group validator (T4): same
 * exactly-one-skill.md semantics as before, plus the case-insensitive
 * near-miss detection shared with the comparison/compliance forms.
 */
export const genericConfigurationFileValidator: (
  group: AbstractControl,
) => ValidationErrors | null = skillMdConfigurationFileValidator(
  'configurationFile',
  ['sourceFiles'],
);
